export default {
  name: "PresenceIndicator",
  props: {
    editors: {
      type: Array,
      default: () => [],
    },
    currentUserSub: {
      type: String,
      default: "",
    },
  },
  methods: {
    editorDisplayName(editor) {
      if (editor.userSub === this.currentUserSub) {
        return editor.userName ? `${editor.userName}（自分）` : "自分";
      }
      return editor.userName || "不明なユーザー";
    },
    editorTooltip(editor) {
      const name = this.editorDisplayName(editor);
      return `${name} が編集中`;
    },
  },
};
